import { useTranslation } from 'react-i18next';
import type { UseFormReturn } from 'react-hook-form';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';
import { useEffect } from 'react';
import { ControlledDropdown } from '../components/controlled-dropdown/ControlledDropdown';
import { occurrenceModules } from './occurrences';
import { options } from './select-options';

export type SelectOccurrenceFormType = Static<typeof SelectOccurrenceFormSchema>;
export const SelectOccurrenceFormSchema = Type.Object(
  {
    occurrenceModule: Type.Union(occurrenceModules.map((module) => Type.Literal(module))),
  },
  { additionalProperties: true, $id: 'SelectOccurrenceFormSchema' }
);

export type SelectOccurrenceProps = {
  form: UseFormReturn<SelectOccurrenceFormType>;
  onValidation: (moduleType: string, isValid: boolean) => void;
};

export const SelectOccurrence: React.FC<SelectOccurrenceProps> = ({ form, onValidation }) => {
  const { t } = useTranslation();

  useEffect(() => {
    const isValid = form.formState.isValid;
    onValidation('occurrence-module', isValid);
  }, [form.formState, onValidation]);

  return (
    <div>
      <form>
        <ControlledDropdown
          id="select-occurrence-module"
          control={form.control}
          name="occurrenceModule"
          label={t('lottery-form-occurrence-module-label')}
          options={options.map(({ translationKey, value }) => ({
            name: t(translationKey),
            value,
          }))}
          errorMessage={undefined}
          hintText={t('lottery-form-occurrence-module-placeholder')}
        />
      </form>
    </div>
  );
};
